import { Box } from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

import Text from "../text/Text";
import { verifyMobileNumber } from "../messages";
import { verifyMobileIcon } from "../images";

function VerifyPhoneNumberBar({ navigate, daysLeft }) {
  return (
    <Box
      className="verify-mobile-bar"
      onClick={() => navigate("/phone-number-verification")}
    >
      <Box display="flex" alignItems="center" gap={1}>
        <img
          src={verifyMobileIcon}
          height={20}
          width={20}
          alt="verify mobile icon"
        />
        <Text className="default-text" size={16} font="semibold">
          {verifyMobileNumber}
          {daysLeft && `(${daysLeft}d left)`}
        </Text>
      </Box>
      <KeyboardArrowRightIcon sx={{ color: "#041F61" }} />
    </Box>
  );
}

export default VerifyPhoneNumberBar;
